export { Input } from './input.component';
